import clsx from "clsx"
import { FC, PropsWithChildren } from "react"
import { useTranslation } from "react-i18next"
import { ClockIcon, HomeMenuBlockImg } from "@/assets"
import { OutlinedText } from "@/ui/OutlinedText"
import { ButtonInRock } from ".."
import styles from "./HomeMenuItem.module.scss"
import { IHomeMenuItem } from "./types"
import { HomeMenuItemContainerMask } from "./ui/HomeMenuItemConainerMask"

export const HomeMenuItem: FC<PropsWithChildren<IHomeMenuItem>> = ({
  children,

  isDisabled = false,
  title,
  button,

  className,
  classNameContent,
  ...rest
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={clsx(styles.HomeMenuItem, className, {
        [styles.disabled]: isDisabled
      })}
      {...rest}
    >
      {isDisabled && (
        <div className={clsx(styles.HomeMenuItem_disabled)}>
          <ClockIcon />
          {t("button.comingSoon")}
        </div>
      )}

      <HomeMenuItemContainerMask />
      <div className={clsx(styles.HomeMenuItem_block)}>
        <img src={HomeMenuBlockImg} alt="home menu block" />
      </div>
      <OutlinedText className={clsx(styles.HomeMenuItem_title)}>
        {title}
      </OutlinedText>
      <div className={clsx(styles.HomeMenuItem_content, classNameContent)}>
        {children}
      </div>
      <ButtonInRock
        classNameContainer={clsx(styles.HomeMenuItem_button)}
        {...button}
      >
        {button?.title}
      </ButtonInRock>
    </div>
  )
}
